import React, { Component } from 'react';
import { HeaderSub } from '../../Common/HeaderSub'
import { HeaderSub2 } from '../../Common/HeaderSub2'
import { SearchText } from '../../Common/SearchText'
import { AllGoodsList } from './AllGoodsList';
import { CategoryList } from './CategoryList';
import { GoodsDtl } from './GoodsDtl';
import { SearchHome } from './SearchHome';
import { SearchList } from './SearchList';
import { StoreList } from '../Store/StoreList';
import { StoreDtl } from '../Store/StoreDtl';

import { GoodsZoom } from './GoodsZoom';
import { StoreGoods } from './StoreGoods';
import { StoreGoodsList } from './StoreGoodsList';

import { Big3Common } from '../../../js/IncludeManager'


/* 개발담당:양유빈
 * 화면기능:매장검색 리스트
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.SearchHome,
            ContentState: null,
            SearchText:""
        };
        if (Big3Common.Util.GetParams("ManCd") !== null) {
            const ManCd = Big3Common.Util.GetParams("ManCd");
            if (ManCd === "all") {
                this.state.RenderName = "AllGoodsList";
            }
            else if (ManCd === "goods") {
                this.state.RenderName = "StoreGoods";
            }
            else {
                this.state.RenderName = "CategoryList";
                this.state.ContentState = { ManCd: ManCd };
            }
        }
        else if (Big3Common.Util.GetParams("Uid") !== null) {
            const Uid = Big3Common.Util.GetParams("Uid");
            if (Big3Common.Util.GetParams("Goods_No") !== null) {
                const Goods_No = Big3Common.Util.GetParams("Goods_No");
                this.state.RenderName = "GoodsDtl"
                this.state.ContentState = { Uid: Uid, Goods_No: Goods_No };
            }
            else {
                this.state.RenderName = "StoreDtl";
                this.state.ContentState = { Uid: Uid };
            }
        }
        else {
            this.state.RenderName = "SearchHome";
        }
        
         
        this.CallBackText = React.createRef();
        this.refSearchList = React.createRef();
        this.refStoreList = React.createRef();
        this.Search_KeyPress = this.Search_KeyPress.bind(this);
        this.SetKeyWord_TextBox = this.SetKeyWord_TextBox.bind(this);
    }
    //호출할 컴포넌트 이름
    CompName = {
        "AllGoodsList": "AllGoodsList",
        "CategoryList": "CategoryList",
        "GoodsDtl": "GoodsDtl",
        "Purchase": "Purchase",
        "SearchHome": "SearchHome",
        "SearchList": "SearchList",
        "StoreList": "StoreList",
        "StoreDtl": "StoreDtl",
        "GoodsZoom": "GoodsZoom",
        "StoreGoods": "StoreGoods",
        "StoreGoodsList": "StoreGoodsList",
    }
    
    //초기화
    componentDidMount() {
         
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    //TextBox 검색어 엔터 후 요청
    Search_KeyPress() {
         
        let SearchText = this.CallBackText.current.GetSearchTextRef();
        if (this.state.RenderName === this.CompName.SearchHome) {
            if (SearchText === "") {
                return false;
            }
            this.setState({ "RenderName": this.CompName.SearchList, "SearchText": SearchText });
        }
        else {
            this.setState({ "SearchText": SearchText });
        }  
    }
    SetKeyWord_TextBox(keyword) {
        this.CallBackText.current.SetSearchTextRef(keyword);
        this.setState({ "RenderName": this.CompName.SearchList, "SearchText": keyword });
    }
    renderPick() {
        
        if (this.state.RenderName === this.CompName.SearchHome) {
            //검색홈
            return (
                <div>
                    <SearchText
                        ref={this.CallBackText}
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        KeyPress={this.Search_KeyPress}
                        Blur={this.Search_KeyPress}
                    />
                    <SearchHome
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        SetKeyWord={this.SetKeyWord_TextBox}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.SearchList) {
            //상품검색
            if (this.refSearchList.current !== null) {
                this.refSearchList.current.SetSearchText(this.state.SearchText);
            }

            return (
                <div>
                    <SearchText
                        ref={this.CallBackText}
                        ComponentUrl="SearchHome"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        KeyPress={this.Search_KeyPress}
                        Blur={this.Search_KeyPress}
                    />
                    <SearchList
                        ref={this.refSearchList}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        SearchText={this.state.SearchText}
                        SetKeyWord={this.SetKeyWord_TextBox}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreList) {
            //매장검색
            if (this.refStoreList.current !== null) {
                this.refStoreList.current.SetSearchText(this.state.SearchText);
            }
            return (
                <div>
                    <SearchText
                        ref={this.CallBackText}
                        ComponentUrl="SearchHome"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        KeyPress={this.Search_KeyPress}
                        Blur={this.Search_KeyPress}
                    />
                    <StoreList
                        ref={this.refStoreList}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        SearchText={this.state.SearchText}
                        SetKeyWord={this.SetKeyWord_TextBox}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreDtl) {
            //매장상세
            return (
                <div>
                    <StoreDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.AllGoodsList) {
            //전체상품 검색
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="전체상품"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <AllGoodsList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.CategoryList) {
            //카테고리 검색
            let HeaderTitle = "";
            if (this.state.ContentState !== null) {
                let ManCd = this.state.ContentState.ManCd;
                if (ManCd === "001") {
                    HeaderTitle = "여성";
                }
                else if (ManCd === "002") {
                    HeaderTitle = "남성";
                }
                else if (ManCd === "003") {
                    HeaderTitle = "잡화";
                }
                else if (ManCd === "004") {
                    HeaderTitle = "유·아동";
                }
                else {
                    HeaderTitle = "전체";
                }
            }
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle={HeaderTitle}
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <CategoryList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsDtl) {
            //상품상세
            return (
                <div>
                    <GoodsDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsZoom) {
            //상품상세
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="상세이미지"
                        ComponentUrl="GoodsDtl"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <GoodsZoom
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreGoods) {
            //도매상가 층
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="상가선택"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <StoreGoods
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreGoodsList) {
            //도매상가 층별 상품 리스트
            const CsName = Big3Common.ContentState;
            const Bld_Name = Big3Common.Util.GetContentState(this.state.ContentState, CsName.Bld_Name, "");
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle={Bld_Name}
                        ComponentUrl="StoreGoods"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <StoreGoodsList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            )
        }
        
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
